import * as S from './styles';
import { colors } from '@/constants';
import { ClientProps, EventsClientParcelaProps } from '@/types';
import { Modal } from '@/components';
import { formatCurrency } from '@/shared';
import { useTables } from '@/hooks';

interface Props {
  client: ClientProps;
  isOpen: boolean;
  closeModal: (value: boolean) => void;
}

const Parcela = (props: EventsClientParcelaProps & { parcelas: number; index: number }) => {
  const status = (props?.status || 'ABERTO') as 'PAGO' | 'VENCIDO' | 'ABERTO';

  return (
    <S.Row $borderBottom $justify="none" $gap={15}>
      <S.Label $weight={700}>
        Parcela
        <S.Label $weight={400} $pl={4}>
          {props.index + 1}/{props.parcelas}
        </S.Label>
      </S.Label>

      {props?.dt_vencimento && <S.Label>{props?.dt_vencimento.replaceAll('-', '/')}</S.Label>}

      <S.Tag $color={status}>
        <S.Label $weight={600} $color={status as any} $size={12}>
          {status}
        </S.Label>
      </S.Tag>

      <S.Label $weight={600}>{formatCurrency({ value: props.vlr_original, isFormat: true })}</S.Label>
      {/* <RiBarcodeFill size={20} color={isPaid ? colors.transparent : colors.brand.grafite} /> */}
    </S.Row>
  );
};

const ModalBoleto = ({ client, isOpen, closeModal }: Props) => {
  const { tables } = useTables();
  const eventos = tables.current.eventos;

  return (
    <Modal
      isOpen={isOpen}
      id={`modal-boleto-${client.COD_CLIENTE}`}
      isScrollable={false}
      dragHeaderColor={colors.gray.gray30}
      closeModal={closeModal}
    >
      <S.Content>
        <S.Header />
        <S.Scrollable>
          {eventos?.[client.COD_CLIENTE]?.boletos?.map((boleto, i) => {
            const totalValue = boleto.parcelas.reduce((acc, parcela) => acc + parcela.vlr_original, 0);

            return (
              <S.Card key={`${boleto.nro_nota}-${i}`}>
                <S.Row $bgColor>
                  <S.Label $weight={700}>Nº da nota</S.Label>
                  <S.Label>{boleto.nro_nota}</S.Label>
                </S.Row>

                <S.Row>
                  <S.Label $weight={700}>Nº do pedido</S.Label>
                  <S.Label>{boleto.nro_pedido}</S.Label>
                </S.Row>

                <S.Row $bgColor>
                  <S.Label $weight={700}>Valor total</S.Label>
                  <S.Label>{formatCurrency({ value: totalValue, isFormat: true })}</S.Label>
                </S.Row>

                {boleto.parcelas?.map((parcela, index) => (
                  <Parcela key={`${boleto.nro_nota}-p-${index}`} {...parcela} parcelas={boleto.parcelas.length} index={index} />
                ))}
              </S.Card>
            );
          })}
        </S.Scrollable>
      </S.Content>
    </Modal>
  );
};

export default ModalBoleto;
